import Menu from "../components/Menu";

function GamePage() {
    return (
        <Menu />
    );
}

export default GamePage;